import { DimOverlay, Image, ImageLoadingStrategy } from '@monofe/ui-common/misc';
import FadeTransition from '@monofe/ui-common/transition/FadeTransition';
import { memo, useCallback } from 'react';
import isEqual from 'react-fast-compare';
import ListView from './ListView';
import { StyleElement, classNameForElement, styleForElement } from './MainView.style';
import NavBarView from './NavigationBarView';
import SideMenuView from './SideMenuView';
import type { IHamburgerViewProperties } from './interface';

function View(properties: IHamburgerViewProperties): JSX.Element {
    const style = useCallback(
        (element: StyleElement) => styleForElement(element, properties),
        [properties],
    );
    const className = useCallback(
        (element: StyleElement) => classNameForElement(element, properties),
        [properties],
    );

    return (
        <FadeTransition
            className={className(StyleElement.Container)}
            style={style(StyleElement.Container)}
        >
            <Image
                urls={properties.backgroundImage.urls}
                mode={properties.backgroundImage.mode}
                className={className(StyleElement.BackgroundImage)}
                style={style(StyleElement.BackgroundImage)}
                loading={ImageLoadingStrategy.Eager}
            />
            {/* This div is needed to show when user #ListView scrolls beyond its bounds & reveals behind itself. 
                At which point this fixed view will be visible & show props.backgroundColor */}
            <div
                aria-hidden
                className={className(StyleElement.BackgroundCover)}
                style={style(StyleElement.BackgroundCover)}
            />
            {properties.sideMenu.isShowing && (
                <DimOverlay
                    isDim={properties.sideMenu.isShowing}
                    zIndex={2}
                    onClick={() => {
                        properties.sideMenu.onOverlayClick();
                    }}
                />
            )}

            <SideMenuView {...properties.sideMenu} />
            <NavBarView {...properties.navBar} />
            <ListView {...properties.collection} />
        </FadeTransition>
    );
}

function propertiesEqual(
    previous: IHamburgerViewProperties,
    next: IHamburgerViewProperties,
): boolean {
    const match = isEqual(previous, next);
    return match;
}

export default memo(View, propertiesEqual);
